module.exports = __webpack_public_path__ + "static/media/apple.f9005bfd.png";